export default {
  order: {
    name: '订单',
    prop: {
      trade_number: '订单编号',
      evcs_seq: '互联互通编号',
      ev_charging_gun: '充电桩',
      station: '电站',
      consumed_power: '电量',
      amount: '实付金额',
      payable_amount: '应付金额',
      service_amount: '服务费',
      service_amount_after_discount: '优惠后服务费',
      charge_amount: '电费',
      preset_amount: '启动预设金额',
      preset_power: '启动预设电量',
      order_source_type: '订单来源',
      charging_started_at: '充电启动时间',
      charging_finished_at: '充电结束时间',
      paid_at: '订单支付时间',
      user: '用户',
      service_provider: '运营商',
      status: '状态',
      extra: '额外信息',
      auto_pay: '是否自动扣费',
      net_income_amount: '预计净收入',
      car: '充电的车辆',
      magcard_number: '刷卡启动的磁卡',
      evcs_user_unique_id: '互联互通车主',
      discount_amount: '优惠金额',
      has_settled: '是否已结算',
      has_receipt: '是否已开票',
      parking_fee_relief_plate_number: '减免车牌',
      ev_charging_station: '充电站',
      // 关键词搜索
      order_trade_number: '订单编号',
      ev_charging_gun_serial_number: '桩编号',
      ev_charging_station_name: '充电站名',
      charge_record_evcs_seq: '互联互通单号',
      vin: 'VIN',
      plate_number: '充电的车牌号码',
      user_cars: '车主认证车辆',
      has_refund: '是否有退款',
      idle_fee_amount: '占位费',
      charging_card_amount: '充电卡扣除金额',
      charging_order_payable_amount: '服务费+电费',
      charger_rated_power: '电桩额定功率',
      idle_fee_bill: '占位费账单',
      ws_subscripted_at: 'Socket订阅时间',
      billing_type: '计费方式',
      idle_fee_bill_status: '占位状态'
    },
    has_charging_discount_options: {
      true: '有',
      false: '无'
    },
    used_charging_card_options: {
      true: '是',
      false: '否'
    },
    order_health_check_statuses: {
      healthy: '健康',
      unhealthy: '不健康'
    },
    order_health_check_module_healthies: {
      true: '健康',
      false: '异常'
    },
    order_health_check_battery_types: {
      other_battery: '其他',
      lithium_iron_phosphate: '磷酸铁锂',
      ternary_lithium_battery: '三元锂'
    },
    is_prepaid_charges: {
      true: '是',
      false: '不是'
    },
    is_vip_orders: {
      true: '是',
      false: '不是'
    },
    has_receipts: {
      true: '已开票',
      false: '未开票'
    },
    has_settleds: {
      true: '已结算',
      false: '未结算'
    },
    statuses: {
      in_progress: '进行中',
      closed: '已关闭',
      unpaid: '未支付',
      paid: '已支付'
    },
    full_discount_types: {
      normal_day_discount: '普通会员优惠',
      member_day_discount: '会员日优惠',
      non_community_group: '家庭/普通集团优惠',
      community_group: '社群优惠',
      charging_package: '充电包优惠',
      coupon: '优惠券优惠'
    },
    order_health_check_types: {
      has_charger_offline_alarm: '桩离网',
      has_energy_loss_alarm: '电桩电损有点高',
      has_insufficient_power_supply_alarm: '功率不足',
      has_order_power_loss_alarm: '计费电量不足',
      has_meter_reading_zero_alarm: '电表计数为零',
      has_module_breakdown_alarm: '模块损坏'
    },
    order_start_modes: {
      app_start: 'App',
      card_start: '刷卡',
      charger_start: '充电桩',
      platform_start: '平台',
      wechat_mini: '微信小程序',
      alipay_mini: '支付宝小程序',
      vin_start: 'VIN码'
    },
    order_stop_modes: {
      app_stop: 'App',
      platform_admin_stop: '平台人工',
      charger_stop: '电桩',
      preset_power_stop: '预设电量',
      preset_amount_stop: '预设金额',
      platform_auto_stop: '平台自动',
      appointment_stop: '预约时间'
    },
    auto_pays: {
      true: '自动支付',
      false: '手动支付'
    },
    billing_types: {
      platform_billing: '平台计费',
      device_billing: '设备计费'
    },
    titles: {
      base_info: '基本信息',
      user_info: '用户信息',
      device_info: '站桩设备',
      repair_order: '修复订单',
      pay_order: '支付订单',
      stop_order: '停止订单',
      order_health_check: '健康分析',
      cancel_order: '撤销订单的支付状态'
    },
    order_types: {
      normal: '收费充电',
      internal: '内部充电'
    },
    payment_types: {
      wechat: '微信支付',
      alipay: '支付宝支付',
      apple_pay: 'Apple Pay',
      balance_pay: '余额支付',
      union_pay: '银联支付',
      offline_pay: '平台支付',
      ccb_pay: '建行支付',
      group_balance_pay: '集团共享资金池',
      refund_pay: '退款支付'
    },
    has_refunds: {
      true: '有退款',
      false: '无退款'
    },
    unit: {
      kwh: '度',
      rmb: '元'
    },
    status: {
      in_progress: '进行中',
      closed: '已关闭',
      unpaid: '未支付',
      paid: '已支付'
    },
    idle_fee_bill: {
      idle_fee_amount: '占位费金额',
      idle_fee_duration: '占位时长',
      idle_fee_begin_at_to_finshed_at: '占位时间',
      status: '支付状态',
      has_settled: '结算状态'
    },
    idle_fee_bill_status: {
      idle_fee_without_bill: '无账单',
      idle_fee_pending: '占位中',
      idle_fee_billed: '已出账'
    },
    index: {
      order_statistics: '订单统计'
    },
    attr: {
      trade_number: '订单号',
      user_id: '用户',
      user: '用户',
      charger_info: '桩信息',
      charging_started_at: '启动时间',
      charging_finished_at: '结束时间',
      charge_in_in_progress: '充电进度',
      billing_info: '计费信息',
      discount_info: '优惠信息',
      start_and_stop: '启停',
      status: '状态',
      stationable_type: '站属性',
      start_mode: '启动方式',
      has_refund: '是否有退款',
      auto_pay: '是否自动支付',
      coupon_definition: '使用优惠券',
      group: '使用集团',
      charging_package_definition: '使用充电包',
      service_provider: '运营商',
      ev_charging_station: '所属充电站',
      has_car: '是否有减免车牌',
      has_charging_discount: '是否有优惠',
      has_vin: '是否有VIN码',
      charge_amount: '充电金额',
      consumed_power: '充电电量',
      consumed_minutes: '充电时长',
      payment_type: '支付方式',
      stop_mode: '停止来源',
      magcard_number: '磁卡',
      charging_package: '单一充电包',
      order_type: '订单类型',
      has_receipt: '是否已开票',
      has_settled: '是否已结算',
      order_source_type: '订单来源',
      has_idle_fee: '是否有占位费',
      used_charging_card: '是否使用充电卡',
      discount_type: '优惠类型',
      is_vip_order: '是否会员订单',
      prepaid_charge: '是否预付订单',
      order_health_check_status: '订单健康状态',
      order_health_check_type: '订单异常类型',
      has_energy_loss_alarm: '电桩电损有点高',
      has_insufficient_power_supply_alarm: '功率不足',
      has_order_power_loss_alarm: '计费电量不足',
      has_meter_reading_zero_alarm: '电表计数为零',
      has_charger_offline_alarm: '桩离网',
      has_module_breakdown_alarm: '模块损坏',
      module_healthy: '模块健康',
      power_difference: '差额{0}kW',
      no_alarm: '订单没有告警',
      export_order_settlement: '导出订单结算明细'
    },
    detail_tags: {
      detail: '基本信息',
      state_analysis: '状态分析',
      order_analysis: '订单分析'
    },
    btn: {
      battery_check: '电池健康分析',
      stop_order: '停止充电',
      stop_charging: '停止充电',
      pay_order: '支付订单',
      repair_order: '修复订单',
      refund_order: '退款申请',
      cancel_order: '撤销订单',
      close_order: '关闭订单'
    },
    stationable_types: {
      ChargeStation: '平台监控',
      EvcsStation: '互联互通'
    },
    discount_stacking_unrestricted: {
      false: '优惠互斥',
      true: '优惠叠加'
    },
    order_source_types: {
      ecmp: 'ECMP',
      evcs: '互联互通'
    },
    parking_relief_results: {
      succeed: '车牌已减免',
      no_action: '车牌未减免',
      unknown: '车牌减免未知'
    },
    show: {
      go_to: '要跳转到',
      // 第三方
      idle_fee_relief: '免占位费'
    },
    search_condition: {
      placeholder: {
        service_provider: '请选择运营商',
        stationable_type: '请选择站属性',
        start_mode: '请选择启动方式',
        payment_type: '请选择支付方式',
        has_car: '请选择是否有车牌',
        has_vin: '请选择是否有VIN码',
        has_refund: '请选择是否有退款',
        has_settled: '请选择是否已结算',
        has_discount: '有优惠/没有优惠',
        stop_mode: '请选择停止来源',
        select_auto_pay: '自动/手动支付',
        has_idle_fee: '请选择是否有占位费',
        used_charging_card: '请选择是使用充电卡',
        select_discount_type: '会员/社群/优惠券/充电包',
        order_health_check_status: '健康/不健康',
        is_prepaid_charge: '请选择是否是预付订单',
        has_receipt: '请选择是否已开票',
        select_order_health_check_type: '请选择异常类型',
        order_type: '请选择订单类型'
      }
    },
    order_analysis: {
      title: '用户最近订单',
      last_10: '用户最近的10条充电记录',
      attr: {
        trade_number: '订单号',
        charge_station_charger: '使用站桩',
        charging_started_at: '充电开始时间',
        charging_finished_at: '充电结束时间',
        stop_reason: '结束原因',
        consumed_time: '充电时长',
        consumed_power: '电量(度)',
        amount: '充电金额(元)',
        user: '充电用户'
      },
      recent_order: '当前电桩最近订单',
      current_order_last_10: '当前电桩最近的10条充电记录'
    },
    state_analysis: {
      status: '{0}状态',
      idle_fee_status: '占位状态',
      compare_charger_placeholder: '选择对比桩',
      using_guns_count: '同时充电枪数：{0}'
    },
    labels: {
      orders_amount: '实付金额',
      idle_fee_amount: '占位费',
      discount_amount: '优惠金额',
      consumed_power: '总电量',
      group_discount_amount: '集团优惠',
      charging_package_discount_amount: '充电包',
      coupon_discount_amount: '优惠券',
      balance_pay: '个人余额支付',
      select_discount: '可选优惠',
      group_balance_pay: '资金池支付',
      pre_settlement_amount: '预计净收入',
      sharing_amount: '渠道分成',
      transaction_fee_amount: '手续费',
      service_amount: '服务费',
      service_amount_after_discount: '优惠后服务费',
      total_active_power: '充电功率 (kW)',
      dc_needs_power: '需求功率 (kW)',
      charge_soc: '充电SOC (%)',
      gun_temperature: '枪温度 (°C)',
      refund_amount: '退款金额',
      dc_current: '实际电流(A)',
      bms_current: 'BMS电流(A)',
      dc_needs_current: '需求电流(A)',
      dc_voltage: '实际电压(V)',
      bms_voltage: 'BMS电压(V)',
      dc_needs_voltage: '需求电压(V)',
      group_discount: '集团优惠',
      charging_package_discount: '充电包优惠',
      coupon_discount: '优惠券优惠',
      member_discount: '会员优惠',
      charging_card_amount: '充电卡支付',
      settlement_amount: '结算金额(元)',
      settlement_charging_amount: '充电实付',
      discount_consumed_power: '充电包优惠电量',
      other_statistics: '其他统计',
      order_health_check_status: '健康状态',
      order_health_check_module_healthy: '模块状态',
      order_health_check_detail: '异常明细',
      order_health_check_using_guns_count: '同时充电枪数'
    },
    placeholder: {
      charging_package_count: '有 {0} 个充电包',
      coupon_count: '有 {0} 张优惠券',
      group_discount_count: '有 {0} 个集团优惠',
      select_order_source_type: 'ECMP/互联互通'
    },
    list_tabs: {
      all: '全部订单',
      in_progress: '充电中',
      unpaid: '未支付',
      has_settled: '已结算',
      unhealthy: '异常'
    },
    validates: {
      coupon_and_group_either_or: '优惠互斥，所选优惠券和集团优惠只能二选一',
      coupon_and_vip_either_or: '优惠互斥，所选优惠券和会员优惠只能二选一',
      discount_amount_over: '优惠金额超出订单应付金额'
    },
    tips: {
      settlement_amount: '当前结算计算只包含充电费和服务费部分的结算，占位费另外计算',
      payment_success: '订单支付成功'
    }
  }
}
